import { Trans, useTranslations } from "adapters/i18n";
import Auth from "features/authentication/Auth";
import ConfirmationModal from "features/shared/components/confirmationModal";
import React from "react";

const ModalNoClient = ({ classes }) => {
  const { t } = useTranslations();

  return (
    <ConfirmationModal
      classNames={{
        submitButtonClass: classes.submitButtonClass,
        customClass: classes.customClass,
        submitButtonContainer: classes.submitButtonContainer,
      }}
      title={
        <span className={classes.modalTitle}>
          {t("errors:no-linked-client.title")}
        </span>
      }
      text={
        <span className={classes.modalText}>
          <Trans
            i18nKey="errors:no-linked-client.description"
            components={{
              highlight: <span className={classes.modalTextInfo} />,
              br: <br />,
            }}
          />
        </span>
      }
      submitButtonTitle={t("common:actions.close")}
      onSubmit={Auth.logout}
      onClose={Auth.logout}
    />
  );
};

export default ModalNoClient;
